import React, { FC } from "react";
import { Box, Typography } from "@mui/material";
import Badge from "../../../../assets/hamaspik/Badge";
import { PifApprovalAuditEntry, PifApprovalChainEntry } from "../types";
import "./PifApprovalReview.scss";

interface PifApprovalChainRailProps {
  chain: PifApprovalChainEntry[];
  audit: PifApprovalAuditEntry[];
}

const DOT_CLASS: Record<PifApprovalChainEntry["state"], string> = {
  done: "pif-approval-rail__dot--done",
  current: "pif-approval-rail__dot--current",
  waiting: "",
};

const PifApprovalChainRail: FC<PifApprovalChainRailProps> = ({ chain, audit }) => (
  <Box className="pif-approval-rail">
    <Box className="pif-approval-rail__card">
      <Typography className="pif-approval-rail__heading">SIGNATURE HISTORY</Typography>
      <Box className="pif-approval-rail__chain">
        {chain.map((c, i) => (
          <Box key={c.name} className="pif-approval-rail__chain-row">
            <Box className="pif-approval-rail__chain-track">
              <Box className={`pif-approval-rail__dot ${DOT_CLASS[c.state]}`}>{c.state === "done" ? "✓" : i + 1}</Box>
              {i < chain.length - 1 && (
                <Box className={`pif-approval-rail__line${c.state === "done" ? " pif-approval-rail__line--done" : ""}`} />
              )}
            </Box>
            <Box className={`pif-approval-rail__chain-body${c.state === "waiting" ? " pif-approval-rail__chain-body--waiting" : ""}`}>
              <Box className="pif-approval-rail__chain-name-row">
                <Typography className={`pif-approval-rail__chain-name${c.state === "current" ? " pif-approval-rail__chain-name--current" : ""}`}>
                  {c.name}
                </Typography>
                {c.state === "current" && (
                  <Badge variant="primary" size="sm">
                    You
                  </Badge>
                )}
              </Box>
              <Typography className="pif-approval-rail__chain-role">{c.role}</Typography>
              <Typography className="pif-approval-rail__chain-detail">{c.detail}</Typography>
              {c.stamp && <Typography className="pif-approval-rail__chain-stamp">{c.stamp}</Typography>}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>

    <Box className="pif-approval-rail__card">
      <Typography className="pif-approval-rail__heading">AUDIT TRAIL</Typography>
      <Box className="pif-approval-rail__audit">
        {audit.map((a) => (
          <Box key={a.what} className="pif-approval-rail__audit-row">
            <Typography className="pif-approval-rail__audit-what">{a.what}</Typography>
            <Typography className="pif-approval-rail__audit-when">{a.when}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  </Box>
);

export default PifApprovalChainRail;
